class BindingHelper {

    static map(object1, object2, $isArray = false) {
        if (!$isArray) {
            for (const [key, value] of Object.entries(object2)) {
                if (object2[key] != null)
                    object1[key] = object2[key]
            }
            return object1;
        }
        else {
            var array = [];
            for (var i = 0; i < object2.length; i++) {
                var a = {};
                for (const [key, value] of Object.entries(object2)) {
                    if (object2[key] != null)
                        a[key] = object2[key]
                }
                array.push(a)
            }
            return array;
        }
    }
}

export default BindingHelper